import { PiechartData } from '../models/plots/piechart-data.model';
import { PieChartInput } from '../models/plots/piechart-input.model';
import { PlotlyPlot } from '../models/plots/plotly-plot.model';

export class PiechartPlotly {
  public static create(input: PieChartInput): PlotlyPlot<PiechartData> {
    return {
      data: [
        {
          values: input.values,
          labels: input.labels,
          type: 'pie',
          textinfo: 'none',
          marker: {
            colors: input.colors,
          },
          sort: false,
          direction: 'clockwise',
        },
      ],
      layout: {
        font: {
          size: 22,
        },
        showlegend: false, // This hides the legend/table on the right
        margin: {
          b: 20,
          t: 20,
        },
        yaxis: {
          automargin: true,
        },
        xaxis: {
          automargin: true,
        },
      },
      config: {
        scrollZoom: false,
        doubleClick: false,
        displayModeBar: false,
      },
    };
  }
}
